import { FC } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { setCartSidebarOpen } from "@store/slices/cartSlice";

import { useCart } from "@hooks/useCart";

import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

import { brandColorTokens } from "@constants";
import { headerActionButtonStyle, headerBadgeStyle } from "../../Header.styles";

const CartButton: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data: cart } = useCart();

  const cartItemCount = cart?.lines.length ?? 0;
  const isCartFilled = cartItemCount > 0;

  const handleCartOpen = () => dispatch(setCartSidebarOpen(true));

  return (
    <Badge
      badgeContent={cartItemCount}
      color="primary"
      overlap="rectangular"
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={[headerBadgeStyle, { "& .MuiBadge-badge": { top: 4, right: 4 } }]}
    >
      <IconButton
        aria-label={t("basket.buttonTitle")}
        onClick={handleCartOpen}
        data-testid="purchase-sidebar-toggle-button"
        data-cy="app-layout-cart-button"
        data-cy-item-count={cartItemCount}
        data-amp-default-track={true}
        data-amp-event-type="header.button.purchaseSidebarToggle"
        sx={[
          headerActionButtonStyle,
          isCartFilled && {
            bgcolor: brandColorTokens.background.primary,
            borderColor: brandColorTokens.background.primary,
            color: brandColorTokens.text.display,
            "&:hover": { bgcolor: brandColorTokens.background.actionTertiaryDark },
          },
        ]}
      >
        <ShoppingCartOutlinedIcon />
      </IconButton>
    </Badge>
  );
};

export default CartButton;
